import { render, staticRenderFns } from "./OpenSourceLicense.vue?vue&type=template&id=5e86f69b&"
import script from "./OpenSourceLicense.vue?vue&type=script&lang=js&"
export * from "./OpenSourceLicense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports